import { render, staticRenderFns } from "./OrderOrdererInfo.vue?vue&type=template&id=793ff612&"
import script from "./OrderOrdererInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderOrdererInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports